import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import { selectOwnershipStructure } from '~/store/identification-form/selectors.ts';

export const useBeneficiaryOwners = () => {
  const { owners } = useSelector(selectOwnershipStructure) || {};

  const beneficiaryOwners = useMemo(
    () => (owners || []).filter((owner) => owner.isBeneficiary),
    [owners]
  );
  return { beneficiaryOwners };
};
